import { useAtom } from "@reatom/npm-react"

import { Checkbox, Img } from "ui-kit/components-branded/index"
import { expressSlotsAtom } from "modules/PsyCatalog/common/models/filterForm"

export function ExpressFilter() {
    const [value] = useAtom(expressSlotsAtom.inputValue)
    return (
        <Checkbox
            id="express"
            checked={value}
            onChange={() => {
                expressSlotsAtom.onChange()
            }}
        >
            В&nbsp;ближайшие 3&nbsp;дня
            <Img src="zap.png" className="filters__form-checkbox--emoji" />
        </Checkbox>
    )
}
